<script setup>
import { computed } from "vue";

const props = defineProps({
    tabs: Object,
    value: String,
});

const emits = defineEmits(["update:value"]);

const STATUS_PENDING = 0;
const STATUS_OPEN = 1;
const STATUS_COMPLETED = 2;

const activeTab = computed({
    get() {
        return props.value;
    },
    set(value) {
        emits("update:value", value);
    },
});

const clickTab = async (tab) => {
    activeTab.value = tab.key;
};
</script>

<template>
    <div class="list-group">
        <button
            v-for="tab in tabs"
            type="button"
            class="list-group-item list-group-item-action d-flex align-item-center"
            aria-current="true"
            @click="clickTab(tab)"
            :disabled="tab.status == STATUS_PENDING"
        >
            <span
                class="icon me-2 me-lg-3"
                :class="{
                    current: activeTab == tab.key,
                    completed: tab.status == STATUS_COMPLETED,
                }"
            >
                <i
                    v-if="tab.status == STATUS_COMPLETED"
                    class="fas fa-check-circle"
                ></i>
                <i v-else class="far fa-dot-circle"></i>
            </span>
            <span>{{ tab.title }}</span>
        </button>
    </div>
</template>

<style lang="css" scoped>
.icon {
    color: #ccc;
}

.icon.current {
    color: #333;
}

.icon.completed {
    color: #28a745;
}

.icon.disabled {
    color: #ccc;
}
</style>
